module.exports = __webpack_public_path__ + "img/setup_success.e9da8bea.png";